import { render } from "./WelcomeOverlay.vue?vue&type=template&id=9527808c&scoped=true"
import script from "./WelcomeOverlay.vue?vue&type=script&lang=js"
export * from "./WelcomeOverlay.vue?vue&type=script&lang=js"

import "./WelcomeOverlay.vue?vue&type=style&index=0&id=9527808c&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9527808c"]])

export default __exports__